<template>
    <Page withNavbar>
        <Header/>
        <main class="container">
            <!-- info -->
            <BriefInfo
                pictureCover
                :title="config.BRIEF_TITLE"
                :description="config.BRIEF_DESCRIPTION"
                :picture="config.BRIEF_IMAGE || config.BRIEF_IMAGE_MOBILE"
            >
                <Button :color="config.COLOR_PRIMARY" :to="{ name: nextPage }">
                    {{ config.BRIEF_REWARD_CTA }}
                </Button>
            </BriefInfo>
            <!-- Steps -->
            <BriefSteps/>
            <!-- Break -->
            <BriefBreak :picture="config.BRIEF_BREAK_IMAGE"/>
            <!-- Rewards -->
            <BriefInfo
                reverse
                pictureCover
                :title="config.BRIEF_REWARD_TITLE"
                :description="config.BRIEF_REWARD_DESCRIPTION"
                :picture="config.BRIEF_REWARD_IMAGE || config.BRIEF_REWARD_IMAGE_MOBILE"
            >
                <Button :color="config.COLOR_PRIMARY" :to="{ name: nextPage }">
                    {{ config.BRIEF_REWARD_CTA }}
                </Button>
            </BriefInfo>
        </main>
        <transition name="fade">
            <keep-alive>
                <router-view/>
            </keep-alive>
        </transition>
    </Page>
</template>
<script>
import {
    Page, Header, BriefInfo, BriefBreak,
} from '@skeepers/platform-framework/components/desktop';
import { SolutionConsumer, CastingConsumer } from '@skeepers/platform-framework/mixins';

import { BriefSteps } from '@/components/desktop';

export default {
    name: 'Brief',
    components: {
        Page, Header, BriefInfo, BriefBreak, BriefSteps,
    },
    mixins: [SolutionConsumer, CastingConsumer],
    props: {
        next: {
            type: String,
            default: 'typeform',
        },
    },
    computed: {
        nextPage () {
            return this.application.progress === 'UPLOAD' ? 'brief.complete' : this.next;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/colors';

main {
    background-color: $white-dark;
}
</style>
